import type { Container } from 'pixi.js';

/**
 * Generic reusable sprite pool. Acquire pulls from a free list or creates a new
 * object via the factory; release hides it and returns it to the pool.
 *
 * Note: the pool does not add/remove children from any parent container — the
 * reconciler is expected to do that so layer ordering stays explicit.
 */
export class SpritePool<T extends Container> {
  private readonly free: T[] = [];

  constructor(private readonly factory: () => T) {}

  acquire(): T {
    const obj = this.free.pop();
    if (obj) {
      obj.visible = true;
      return obj;
    }
    return this.factory();
  }

  release(obj: T): void {
    obj.visible = false;
    this.free.push(obj);
  }
}
